export interface IFooter {
  Id: string;
  Description: string;
  Sport: ESportFooter;
}

export enum ESportFooter {
  BASEBALL = 'BASEBALL',
  BASKETBALL = 'BASKETBALL',
  FOOTBALL = 'FOOTBALL',
  HANDBALL = 'HANDBALL',
  ICE_HOCKEY = 'ICEHOCKEY',
  AMERICAN_FOOTBALL = 'FUTBOL',
  VOLLEYBALL = 'VOLLEYBALL',
}
